module.exports = __webpack_public_path__ + "img/fal-box-open.fe863eb2.svg";